import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import ContentDownload from '../components/download/ContentDownload';

function Download() {
  return (
    <div className="min-h-screen flex flex-col">
      <Navbar />
      <main className="flex-grow">
        <ContentDownload />
      </main>
      <Footer />
    </div>
  );
}

export default Download;
